import {
  FETCH_POLICIES_REQUEST,
  FETCH_POLICIES_SUCCESS,
  FETCH_POLICIES_FAILURE,
  ADD_POLICY_REQUEST,
  ADD_POLICY_SUCCESS,
  ADD_POLICY_FAILURE,
  UPDATE_POLICY_REQUEST,
  UPDATE_POLICY_SUCCESS,
  UPDATE_POLICY_FAILURE,
  DELETE_POLICY_REQUEST,
  DELETE_POLICY_SUCCESS,
  DELETE_POLICY_FAILURE,
} from '../actions/types';

const initialState = {
  policies: [],
  loading: false,
  error: null,
  message: '',
};

export default function termsAndPoliciesReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_POLICIES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_POLICIES_SUCCESS:
      return {
        ...state,
        loading: false,
        policies: action.payload,
        message: 'Policies loaded successfully',
      };

    case FETCH_POLICIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        policies: [],
      };

    case ADD_POLICY_REQUEST:
      return { ...state, loading: true, error: null };

    case ADD_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        policies: Array.isArray(state.policies) ? [...state.policies, action.payload] : [action.payload],
        message: 'Policy added successfully',
      };

    case ADD_POLICY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_POLICY_REQUEST:
      return { ...state, loading: true, error: null };

      case UPDATE_POLICY_SUCCESS:
        return {
          ...state,
          loading: false,
          policies: Array.isArray(state.policies)
            ? state.policies.map((policy) =>
                policy.id === action.payload.id ? action.payload : policy
              )
            : state.policies, 
          message: 'Policy updated successfully',
        };
      
      
    case UPDATE_POLICY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_POLICY_REQUEST:
      return { ...state, loading: true, error: null };

    case DELETE_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        policies: Array.isArray(state.policies)
          ? state.policies.filter((policy) => policy.id !== action.payload)
          : state.policies,
        message: 'Policy deleted successfully',
      };


    case DELETE_POLICY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
